import { Box, Typography, styled } from '@mui/material'
import { FAIRTRADE_FONT_STACK } from 'src/templates/fairtrade/constants'

export const ImpactTitle = styled(Typography)<{ isMobile?: boolean }>(({ theme, isMobile }) => ({
  position: 'relative',
  width: isMobile ? '70%' : '80%',
  marginTop: '90px',
  marginLeft: theme.spacing(1.25),
  fontWeight: 700,
  fontSize: '32px',
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const ImpactsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const FairtradeImpactCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOdd',
})<{ isOdd: boolean }>(({ theme, isOdd }) => ({
  boxSizing: 'border-box',
  position: 'relative',
  backgroundColor: isOdd ? '#f8f6f4' : '#fff',
  borderRadius: theme.spacing(3),
  padding: '24px',
  boxShadow: '0px 18px 45px rgba(23, 34, 49, 0.08)',
  border: `1px solid rgba(23, 34, 49, 0.05)`,
  [theme.breakpoints.down('sm')]: {
    padding: '24px 14px',
  },
}))

export const FairtradeImpactTitle = styled(Typography)(({ theme }) => ({
  fontSize: '24px',
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary,
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const FairtradeDescriptionWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  color: theme.palette.text.primary,
  '&::after': {
    content: '""',
    display: 'block',
    clear: 'both',
  },
}))

export const FairtradeImpactAvatar = styled('img')(({ theme }) => ({
  width: 152,
  height: 152,
  borderRadius: '50%',
  float: 'right',
  marginLeft: theme.spacing(3),
  marginBottom: theme.spacing(2),
  objectFit: 'cover',
  shapeOutside: 'circle(50%)',
  [theme.breakpoints.down('sm')]: {
    float: 'none',
    margin: '0 auto',
    display: 'block',
    shapeOutside: 'none',
  },
}))

export const FairtradeDetailsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(3),
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(3),
}))

export const FairtradeQuantityBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  minWidth: 140,
}))

export const FairtradeQuantityValue = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '2.25rem',
  lineHeight: 1,
  color: theme.palette.text.primary,
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const FairtradeQuantityLabel = styled(Typography)(({ theme }) => ({
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  fontFamily: FAIRTRADE_FONT_STACK,
}))

export const FairtradeMediaWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
}))

export const FairtradeBottomSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  marginTop: theme.spacing(3),
}))

export const FairtradeMetaActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}))

export const FairtradeAttachmentsWrapper = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
  // backgroundColor: 'rgba(255, 255, 255, 0.7)',
  padding: theme.spacing(1.5),
}))



